module.exports = __webpack_public_path__ + "img/window-dock.bebc1839.svg";